import { render, staticRenderFns } from "./BasePieChart.vue?vue&type=template&id=2c724043&scoped=true"
import script from "./BasePieChart.vue?vue&type=script&lang=js"
export * from "./BasePieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c724043",
  null
  
)

export default component.exports